import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=08361465&scoped=true"
import script from "./AppPage.vue?vue&type=script&lang=ts"
export * from "./AppPage.vue?vue&type=script&lang=ts"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=08361465&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08361465",
  null
  
)

export default component.exports